
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import AppRoutes from "./routes";

const App = () => {
  return (
    <>
      <AppRoutes />
      <ToastContainer />
    </>
  );
};

export default App;